import { makeSelectors } from '@utils/css';

const forcedHeaderStateSelectors = makeSelectors({
  expanded: "header--expanded-force",
  collapsed: "header--collapsed-force"
});

export { forcedHeaderStateSelectors };
//# sourceMappingURL=useForcedHeaderState.selectors.js.map
